<ng1-profile-linked [selectedPerson]="selectedPerson"
                    [isOrganisationAdmin]="isOrganisationAdmin"
                    [isPopup]="isPopup"
                    [organisationTypeId]="organisationTypeId"></ng1-profile-linked>
